"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMediaQuery = void 0;
var react_1 = require("react");
/**
 * Custom hook that tells you whether a given media query is active.
 *
 * Inspired by https://usehooks.com/useMedia/
 * https://gist.github.com/gragland/ed8cac563f5df71d78f4a1fefa8c5633
 */
function useMediaQuery(query) {
    var _a = react_1.useState(false), matches = _a[0], setMatches = _a[1];
    react_1.useEffect(function () {
        var mediaQuery = window.matchMedia(query);
        setMatches(mediaQuery.matches);
        var handler = function (event) { return setMatches(event.matches); };
        mediaQuery.addEventListener("change", handler);
        return function () { return mediaQuery.removeEventListener("change", handler); };
    }, []); // Empty array ensures effect is only run on mount and unmount
    return matches;
}
exports.useMediaQuery = useMediaQuery;
function useBreakpoints() {
    return {
        isMobile: useMediaQuery("(max-width: 991px)"),
        isDesktop: useMediaQuery("(min-width: 992px)"),
    };
}
exports.default = useBreakpoints;
//# sourceMappingURL=useMediaQuery.js.map